var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","light":"","color":"primary"}}):_c('LazyHydrate',{attrs:{"when-idle":""}},[_c('DynamicPageItems',{attrs:{"items":_vm.items,"css-vars-key":_vm.$route.meta.dynamicPageKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }